import { JsonObject } from "@/domains/common/types";

export const _parseObjectFromJson = <TValue = JsonObject>(value: string) =>
  JSON.parse(value) as TValue;
